import { LOADING } from "../../Actions/Types";
import { getUserActivityListApi, postUserActivityListApi } from "../../Api/UserActivity";

// service to get domain list with details
const getUserActivityListService = (
    token: string, // access token
    dispatch: Function, // dispatch function to store redux data
    t: Function, // i18next t function
    setUserActivityList: Function, // function to set domain list
    limit: number, // limit per page
    offset: number, // page offset
    startDate : string, // start date filter
    endDate : string, // end date filter
    setTotalRecord: Function  // function to set displayed record count
) => {

    // Set Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // API to get domain list
    getUserActivityListApi(token, limit, offset, startDate, endDate).then((res) => {
        // check if response is ok
        if (res.status === 200) {

            // Set Website List
            const updateResData = res.data.map((d:any, i:number) => {
                return {
                    ...d,
                    sr_no: offset + (i + 1)
                }
            })
            setUserActivityList(updateResData);
            // Set Record Record
            setTotalRecord(res.total);

            // Set Loading
            dispatch({
                type: LOADING,
                payload: false,
            });
        }
    })
}

// service to get domain list with details
const postUserActivityListService = (
    token: string, // access token
    title : string, // start date filter
    description : string, // end date filter
) => {

    // API to get domain list
    postUserActivityListApi(token, title, description).then((res) => {
        // check if response is ok
        if (res.status === 200) {
            // Set Loading
            return res.Data
        }
    })
}

export { getUserActivityListService, postUserActivityListService }